import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "quickfacts" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "quickfacts__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickfacts, (quickfact) => {
      return (_openBlock(), _createElementBlock("li", {
        key: quickfact.type,
        class: _normalizeClass(["quickfacts__item", `quickfacts__item--icon-${quickfact.type}`])
      }, [
        _createElementVNode("span", {
          class: "quickfacts__label",
          innerHTML: quickfact.name
        }, null, 8 /* PROPS */, _hoisted_2),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createElementVNode("span", _hoisted_3, [
          (_ctx.useLinks || _ctx.splitValues)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(quickfact.valuesAndLinks, (valueAndLink, valueAndLinkIndex) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getTagFor(valueAndLink.second)), {
                  key: valueAndLinkIndex,
                  class: _normalizeClass(["quickfacts__value-item", {'quickfacts__value-item--linked': valueAndLink.second}]),
                  href: valueAndLink.second || null,
                  role: "button",
                  tabindex: "0",
                  onClick: ($event: any) => (_ctx.handleClick(valueAndLink.second)),
                  onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.handleClick(valueAndLink.second)), ["prevent"]), ["enter","space"]),
                  innerHTML: _ctx.valueHtml(valueAndLink.first)
                }, null, 40 /* PROPS, NEED_HYDRATION */, ["class", "href", "onClick", "onKeydown", "innerHTML"]))
              }), 128 /* KEYED_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.valueText(quickfact.valuesAndLinks)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
        ])
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}